// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__16XU_","empty":"ModalGraph_empty__28yyo"};